import { PeriodProvider } from "@/providers/Period";
import Permissoes from "./Permissoes";
import { FaDoorOpen } from "react-icons/fa";
import TipoCarga from "./TipoDeCarga";
import FormaPagamento from "./FormaPagamento";
import Fabricante from "./FabricanteVeiculo";
import ModeloVeiculo from "./ModeloVeiculo";
import TipoCombustivel from "./TipoCombustivel";
import Localidade from "./Localidade";
import Veiculo from "./Veiculo";
import Motorista from "./Motorista";
import Transportadora from "./Transportadora";
import TipoJanela from "./TipoJanela";
import Agendamento from "./Agendamento";


const ModulePortaria = {
  menuItem: {
    to: "/portaria",
    title: "Portaria",
    icon: FaDoorOpen ,
    id: 930,
    childrens: [
      {
        to: "/portaria/permissoes",
        title: "Permissões",
        fullTitle: "Permissões",
        id: 50,
      },
      {
        to: "/portaria/tipocarga",
        title: "Tipo de Carga",
        fullTitle: "Tipo de Carga",
        id: 50,
      },
      {
        to: "/portaria/formapagamento",
        title: "Forma de Pagamento",
        fullTitle: "Forma de Pagamento",
        id: 50,
      },
      {
        to: "/portaria/fabricante",
        title: "Fabricante do Veículo",
        fullTitle: "Fabricante do Veículo",
        id: 50,
      },
      {
        to: "/portaria/modeloveiculo",
        title: "Modelo do Veículo",
        fullTitle: "Modelo do Veículo",
        id: 50,
      },
      {
        to: "/portaria/tipocombustivel",
        title: "Tipo de Combustivel",
        fullTitle: "Tipo de Combustivel",
        id: 50,
      },
      {
        to: "/portaria/veiculo",
        title: "Veiculo",
        fullTitle: "Veiculo",
        id: 50,
      },
      {
        to: "/portaria/motorista",
        title: "Motorista",
        fullTitle: "Motorista",
        id: 50,
      },
      {
        to: "/portaria/localidade",
        title: "Localidade",
        fullTitle: "Localidade",
        id: 50,
      },
      {
        to: "/portaria/transportadora",
        title: "Transpotadora",
        fullTitle: "Transpotadora",
        id: 50,
      },
      {
        to: "/portaria/tipojanela",
        title: "Tipo de Janela",
        fullTitle: "Tipo de Janela",
        id: 50,
      },
      {
        to: "/portaria/agendamento",
        title: "Janela de Agendamento",
        fullTitle: "Janela de Agendamento",
        id: 50,
      },
      
    ],
  },

  routes: [
    {
      path: "/portaria/permissoes",
      element:<PeriodProvider> <Permissoes /></PeriodProvider>,
    },
    {
      path: "/portaria/tipocarga",
      element:<PeriodProvider> <TipoCarga /></PeriodProvider>,
    },
    {
      path: "/portaria/formapagamento",
      element:<PeriodProvider> <FormaPagamento /></PeriodProvider>,
    },
    {
      path: "/portaria/fabricante",
      element:<PeriodProvider> <Fabricante /></PeriodProvider>,
    },
    {
      path: "/portaria/modeloveiculo",
      element:<PeriodProvider> <ModeloVeiculo /></PeriodProvider>,
    },
    {
      path: "/portaria/tipocombustivel",
      element:<PeriodProvider> <TipoCombustivel /></PeriodProvider>,
    },
    {
      path: "/portaria/veiculo",
      element:<PeriodProvider> <Veiculo /></PeriodProvider>,
    },
    {
      path: "/portaria/localidade",
      element:<PeriodProvider> <Localidade /></PeriodProvider>,
    },
    {
      path: "/portaria/motorista",
      element:<PeriodProvider> <Motorista /></PeriodProvider>,
    },
    {
      path: "/portaria/transportadora",
      element:<PeriodProvider> <Transportadora /></PeriodProvider>,
    },
    {
      path: "/portaria/tipojanela",
      element:<PeriodProvider> <TipoJanela /></PeriodProvider>,
    },
    {
      path: "/portaria/agendamento",
      element:<PeriodProvider> <Agendamento /></PeriodProvider>,
    },
    
  ],
};

export default ModulePortaria;
